import LocationInterface from '@solvhealth/types/interfaces/Location';
import { GenericObj } from '@solvhealth/types/interfaces/generics';
// @ts-ignore FIXME: Try `npm install @types/rc-form` if it exists or a... Remove this comment to see the full error message
import { createForm, formShape } from 'rc-form';
import React, { useEffect } from 'react';
import { deleteNullFields, sanitizeForm } from '../../../../../core/util/form';
import PaperworkForm from '../../../PaperworkForm';
import { PaperworkField, getStandardFormFieldData } from '../../../util';
import { MedicalPageNumber } from './constants';
import { PaperworkState } from '~/ducks/paperwork';
import { SectionPage } from '~/components/Paperwork/interfaces';

type Props = {
  bookingId: string;
  form: formShape;
  handleClickNext: (newForm: GenericObj) => void;
  location: LocationInterface;
  onGoForward: () => void;
  pageView: MedicalPageNumber;
  paperwork: PaperworkState;
  preloadedData?: any;
  sectionPage: SectionPage;
};

const MedicalForm = (props: Props) => {
  const {
    form,
    handleClickNext,
    location,
    onGoForward,
    pageView,
    paperwork,
    preloadedData,
    sectionPage,
  } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pageView]);

  const handleNextButtonClick = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    form.validateFields((errors: any, values: any) => {
      if (!errors) {
        const newForm = sanitizeForm(deleteNullFields(values));
        handleClickNext(newForm);
      }

      return null;
    });
  };

  return (
    <PaperworkForm
      form={form}
      onSkip={onGoForward}
      onSubmit={handleNextButtonClick}
      sectionPage={sectionPage}
    >
      {sectionPage.fieldNames?.map((fieldName: string) => {
        return (
          <PaperworkField
            key={fieldName}
            {...{
              field: getStandardFormFieldData(fieldName, paperwork),
              paperwork,
              form,
              preloadedData,
              location,
            }}
          />
        );
      })}
    </PaperworkForm>
  );
};

export default createForm()(MedicalForm);
